const initialState = {
    userData: null,
    subscription: null,
  };
  
  const userReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'UPDATE_USER_SUBSCRIPTION':
        return {
          ...state,
          subscription: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default userReducer;